import { Table } from '~/components/Landing/Table'

export default function TablePage() {
  return <Table />
}
